module.exports = __webpack_public_path__ + "static/img/xinnongxie_icon_pre.49b5a0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/nav/xinnongxie_icon_pre.png
// module id = logF
// module chunks = 22